import React from 'react';
import { useHistory, useParams } from 'react-router';

import { makeStyles, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import ErrorOutlineRoundedIcon from '@material-ui/icons/ErrorOutlineRounded';

import { Endpoint } from '../../../../router/routes.config';
import { replaceParams } from '../../../../router/routes.helpers';

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 0,
    '& svg': {
      fontSize: 80,
      marginRight: theme.spacing(2),
    },
  },
}));

interface ParamTypes {
  organizationId: string;
}

interface IProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function AddStudiotelDialog(props: IProps) {
  const { open, setOpen } = props;
  const { organizationId } = useParams<ParamTypes>();
  const history = useHistory();
  const classes = useStyles();

  function handleClose() {
    setOpen(false);
  }

  function handleConfirm() {
    const path = replaceParams(
      Endpoint.FLEET_ADD_STUDIOTEL,
      [/:organizationId/],
      [organizationId]
    );
    history.push(path);
    setOpen(false);
  }

  return (
    <Dialog id="add-studiotel-dialog" open={open} onClose={handleClose}>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          className={classes.content}
        >
          <ErrorOutlineRoundedIcon fontSize="large" color="primary" />
          Vous vous apprêtez à ajouter un Studioplay, désirez-vous continuer ?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          non
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="outlined"
          autoFocus
        >
          oui
        </Button>
      </DialogActions>
    </Dialog>
  );
}
